<template>
<div class="grid grid-cols-1 2xl:gap-80 2xl:grid-cols-2 col-start-2 mb-20">
    <div class="col-start-1 justify-self-center">
        <div v-for="Timer in Timers.left" :key="Timer">
            <TimerInstance v-bind:id="Timer.Id" v-bind:points="Timer.points" v-bind:name="Timer.name"/>
        </div>
    </div>
    <div class="2xl:col-start-2 col-start-1 justify-self-center">
        <div v-for="Timer in Timers.right" :key="Timer">
            <TimerInstance v-bind:id="Timer.Id" v-bind:points="Timer.points" v-bind:name="Timer.name"/>
        </div>
    </div>
</div>
</template>

<script>
import TimerInstance from './TimerInstance.vue'
export default {
    components: {
        TimerInstance
    },
    data(){
        return{
            socket: this.$store.state.socket,
            Timers: {
                left: [],
                right: [],
                currentInsert: 1
            },
            TimerCount: 0,
        }
    },
    mounted(){
        if(this.socket === null){
            this.$store.commit("changeId", {roomId: this.roomId})
            this.$router.push("/Pregame")
            return 
        }
        this.socket.on("JoinedSuccesfully", (payload) => {
            payload.players.forEach(element => {
                this.addTimer(element)
                this.$store.commit("addPlayer")
            });
        })
        this.socket.on("SomebodyJoined", (payload) => {
            this.addTimer(payload)
            this.$store.commit("addPlayer")
        })
        this.socket.on("leaving", (id) => {
            this.Timers.left.forEach(element => {
                if(element.Id === id){
                    this.Timers.left.splice(this.Timers.left.indexOf(element), 1)
                }
            });
            this.Timers.right.forEach(element => {
                if(element.Id === id){
                    this.Timers.right.splice(this.Timers.right.indexOf(element), 1)
                }
            });
        })
    },
    methods: {
        addTimer: function(payload){
            console.log(this.Timers)
            if(this.Timers.currentInsert === 1){
                this.Timers.left.push(payload),
                this.Timers.currentInsert = 2
            }
            else{
                this.Timers.right.push(payload),
                this.Timers.currentInsert = 1
            }
        },
    },
    computed: {

    }
}
</script>

<style>

</style>